export const DataObjectGroupUrl = {
  GROUP: '/data-object-groups{/id}',
  AUTOCOMPLETE:
    '/data-object-groups/autocomplete{?page,size,sort*,searchText,type,selectedCode}',
  SEARCH:
    '/data-object-groups{?page,size,sort*,code,name,searchText,selectedGroupIds*,selectedSubgroupIds*,description,groupType,includeSystemic}',
  ASSIGNABLE_TO_DESCRIPTIONS:
    '/data-object-groups/assignable-to-descriptions{?page,size,code,groupType}',
  EXTENDED: '/data-object-groups/extended{/id}',
  WITH_DESCRIPTIONS:
    '/data-object-groups/with-descriptions{?groupType,outputType,active}',
} as const;
